const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function approveNewMemberPdfMaker(addr, approveDate, getMember, owners) {
  const member = getMember(addr);
  const title = 'Approving ' + member.name;
  const p = member.name + ' was approved on ' + approveDate;
  const initial1 = 'Wallet: ' + member.address;
  const initial2 = 'E-Mail: ' + member.email;
  const initial3 = 'Position: ' + member.position;
  const initial4 = 'Approver: ' + getMember(member.approver).name;
  const sign2Row: any[] = [];
  const signRow = [
    { text: '\nDirector: ' + getMember(member.approver).name, alignment: 'right' },
    { text: '', alignment: 'right' },
    { text: '\nSignature: ' + getMember(member.approver).name, alignment: 'right', italics: true }
  ];
  function ownerSign(name) {
    return { text: '\nSignature: ' + name, alignment: 'right', italics: true };
  }
  for (let addr in owners) {
    const footerRow = [
      {},
      { text: '\nDirector: ' + getMember(addr).name, alignment: 'right', bold: false },
      { text: '', alignment: 'right' },
      ownerSign(getMember(addr).name)
    ];
    sign2Row.push(footerRow);
  }
  /**
   * Creating a Document Definition Object for pdfmake
   * https://pdfmake.github.io/docs/document-definition-object/
   * @param {string}    text   Text
   * @param {string}    style  Style name
   * @param {number}    fontSize  Font size of text
   * @param {array}     margin Margin of text [left, top, right, bottom]
   */
  const docDefinition = {
    content: [
      {
        text: title,
        style: 'header',
        fontSize: 22,
        margin: [0, 0, 0, 25]
      },
      {
        text: p,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 25]
      },
      {
        text: initial1,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        text: initial2,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        text: initial3,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        text: initial4,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 45]
      },
      {
        table: {
          widths: ['*', '20%', 'auto'],
          body: [signRow],
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 150]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: sign2Row,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'justify'
      }
    }
  };
  return pdfMake.createPdf(docDefinition);
}
